<div class="selector-container grid small grid-two">
  <app-selector
    *ngFor="let entry of dataEntries;
            let isFirst = first;
            let isLast = last"
    [id]="entry.ID"
    [name]="entry.name | translate"
    [description]="entry.description | translate"
    [checked]="entry.checked"
    [imageClassFromFrontEnd]="entry.imageClassFromFrontEnd"
    [isFirst]="isFirst"
    [isLast]="isLast"
    [isSingleItem]="true"
    (selected)="onSelectorClicked($event)"
  ></app-selector>
</div>
